'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _containers = require('../../containers');
var _PublishPropertyFormConstants = require('../../containers/PublishForm/PublishPropertyFormConstants');

var _constants = require('../../constants');

var _multiselectsTitles = require('../../utils/multiselectsTitles');

var _AdditionalFilters = require('./AdditionalFilters.scss');var styles = _interopRequireWildcard(_AdditionalFilters);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Containers
// Constants
// Helpers
// Styles
var AdditionalFilters = function (_Component) {_inherits(AdditionalFilters, _Component);function AdditionalFilters() {var _temp, _this, _ret;_classCallCheck(this, AdditionalFilters);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.defaultProps = { commodities: [] }, _this.
    createField = function (id) {return {
        value: id,
        checked: _this.props.commodities.indexOf(id) !== -1,
        onChange: function onChange(evt) {return _this.props.onChange(evt.currentTarget.value);} };}, _this.


    filterCommodities = function () {var commodities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return commodities.filter(function (_ref) {var id = _ref.id;
        if (_this.props.location === 'commercial') {
          return id !== 'stroller_room';
        }

        if (_this.props.optionType === _constants.optionTypes.buy) {
          return id !== 'roommates';
        }

        return true;
      });}, _temp), _possibleConstructorReturn(_this, _ret);}AdditionalFilters.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,photosField = _props.photosField,vrField = _props.vrField,bathrooms = _props.bathrooms,toilets = _props.toilets;
    var translatePublish = translate('publishProperty');
    var bathTitle = (0, _multiselectsTitles.bathToiletsTitle)(bathrooms || undefined, translate);
    var toiletsTitle = (0, _multiselectsTitles.bathToiletsTitle)(toilets || undefined, translate);

    var propertyCommodities = this.filterCommodities((0, _PublishPropertyFormConstants.commoditiesOptions)(translatePublish));

    return (
      _react2.default.createElement('div', { className: styles.additionalFilterWrapper },
        _react2.default.createElement('div', { className: styles.bathToiletsWrapper },
          _react2.default.createElement('div', { className: styles.bathToiletsRowWrapper },
            _react2.default.createElement('div', { className: styles.titleWrapper },
              _react2.default.createElement('i', { className: 'icon-bathroom' }),
              _react2.default.createElement('span', { className: styles.title }, translate('advancedFilters', 'bath'))),

            _react2.default.createElement('div', { className: styles.selectWrapper },
              _react2.default.createElement(_containers.MultiselectWrapper, {
                options: (0, _constants.bathToiletsOptions)(translate),
                title: bathTitle,
                value: bathrooms,
                onChange: function onChange(value) {return _this2.props.onBathToiletsChange('bathrooms', value);} }))),



          _react2.default.createElement('div', { className: styles.bathToiletsRowWrapper },
            _react2.default.createElement('div', { className: styles.titleWrapper },
              _react2.default.createElement('i', { className: 'icon-restroom' }),
              _react2.default.createElement('span', { className: styles.title }, translate('advancedFilters', 'toilets'))),

            _react2.default.createElement('div', { className: styles.selectWrapper },
              _react2.default.createElement(_containers.MultiselectWrapper, {
                options: (0, _constants.bathToiletsOptions)(translate),
                title: toiletsTitle,
                value: toilets,
                onChange: function onChange(value) {return _this2.props.onBathToiletsChange('toilets', value);} })))),




        _react2.default.createElement('div', { className: styles.commoditiesWrapper },
          _react2.default.createElement('div', { className: styles.commodities },
            propertyCommodities.
            map(function (_ref2) {var id = _ref2.id,label = _ref2.label;return (
                _react2.default.createElement('div', { key: id },
                  _react2.default.createElement(_components.OMCheckbox, {
                    id: id,
                    label: label,
                    field: _this2.createField(id) })));})),





          _react2.default.createElement('div', { className: styles.commodities },
            this.filterCommodities((0, _PublishPropertyFormConstants.additionsOptions)(translatePublish)).
            map(function (_ref3) {var id = _ref3.id,label = _ref3.label;return (
                _react2.default.createElement('div', { key: id }, _react2.default.createElement(_components.OMCheckbox, { id: id, label: label, field: _this2.createField(id) })));})),



          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.commodities, styles.additionalCheckboxes) },
            _react2.default.createElement('div', null,
              _react2.default.createElement(_components.OMCheckbox, {
                id: 'photos',
                label: translate('advancedFilters', 'photos'),
                field: photosField })),


            _react2.default.createElement('div', null,
              _react2.default.createElement(_components.OMCheckbox, {
                id: 'vr',
                label: translate('advancedFilters', 'vr'),
                field: vrField }))))));






  };return AdditionalFilters;}(_react.Component);


AdditionalFilters.propTypes = {
  translate: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  photosField: _propTypes2.default.object,
  vrField: _propTypes2.default.object,
  location: _propTypes2.default.string,
  commodities: _propTypes2.default.array,
  bathrooms: _propTypes2.default.array,
  toilets: _propTypes2.default.array,
  onBathToiletsChange: _propTypes2.default.func,
  optionType: _propTypes2.default.string };exports.default =


AdditionalFilters;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AdditionalFilters/AdditionalFilters.js
// module id = 2622
// module chunks = 0